module.exports = __webpack_public_path__ + "img/logo_new.e7801a37.png";